import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { crudData, defaultImage, fullUrl } from "../../services/apiService";
import { toast } from "react-toastify";
import { formatPrice } from "../../MesPages/Panier/Cart";
import { verifyImageLink } from "../../services/lib";

const ProductWrap = ({ product, userData = {}, col_css, onSuccess }) => {
    const mode = JSON.parse(localStorage.getItem("appMode"));
    const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"));
    const [addedProducts, setAddedProducts] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isAdded, setIsAdded] = useState(false);      // bouton ajouté ou non
    const [quantity, setQuantity] = useState(1);         // quantité actuelle
    const [LG_CPRID, setLG_CPRID] = useState(null);     // ID ligne panier pour update/delete
    const [isLoading, setIsLoading] = useState(false);  // chargement bouton

    const handleClick = () => {
        localStorage.setItem("selectedProductId", product.ArtID);
    };
    

    // ── Ajouter au panier ──────────────────────────────────────────
    const handleAddToCart = () => {
        if (!userData || !userData.STR_UTITOKEN) {
            toast.error("Veuillez vous connecter pour ajouter au panier.");
            return;
        }

        setIsLoading(true);
        const payload = {
            mode: mode.createCommproduittMode,
            LG_AGEID: userData.LG_AGEID,
            STR_COMMNAME: "",
            STR_COMMADRESSE: "Plateau, Pullman",
            STR_LIVADRESSE: "Zone 4, marcory",
            LG_PROID: product.ArtID,
            STR_UTITOKEN: userData.STR_UTITOKEN,
            INT_CPRQUANTITY: 1,
            
        };

        crudData(payload, apiEndpointe.CommandeManagerEndPoint)
            .then((response) => {
                setIsLoading(false);
                if (response.data.code_statut === "1") {
                    setIsAdded(true);
                    setQuantity(1);
                    setLG_CPRID(response.data.LG_CPRID);
                    localStorage.setItem("LG_COMMID", response.data.LG_COMMID);
                    setIsPopupOpen(true);
                    if (onSuccess) onSuccess();
                    setTimeout(() => setIsPopupOpen(false), 3000);
                } else {
                    const errorMsg = response.data?.desc_statut 
                        ? response.data.desc_statut 
                        : "Erreur de connexion au serveur. Veuillez réessayer.";
                    toast.error(errorMsg);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Erreur ajout panier:", error);
                toast.error("Erreur lors de l'ajout au panier.");
            });
    };
    // console.log("Produit complet:", product);
    // console.log("ArtID:", product.ArtID);
    // console.log("ArtCode:", product.ArtCode);

    // ── Augmenter la quantité ──────────────────────────────────────
    const handleIncrease = () => {
        const newQty = quantity + 1;
        setQuantity(newQty);
        updateCartQuantity(newQty);
    };

    // ── Diminuer la quantité ───────────────────────────────────────
    const handleDecrease = () => {
        if (quantity === 1) {
            // Supprimer du panier
            removeFromCart();
        } else {
            const newQty = quantity - 1;
            setQuantity(newQty);
            updateCartQuantity(newQty);
        }
    };

    // ── Mettre à jour la quantité dans l'API ───────────────────────
    const updateCartQuantity = (newQty) => {
        if (!LG_CPRID) return;
        const payload = {
            mode: mode.updateCommproduitMode,
            LG_CPRID: LG_CPRID,
            INT_CPRQUANTITY: newQty,
            STR_UTITOKEN: userData.STR_UTITOKEN,
        };
        crudData(payload, apiEndpointe.CommandeManagerEndPoint)
            .then((response) => {
                if (response.data.code_statut !== "1") {
                    toast.error("Erreur lors de la mise à jour.");
                }
                if (onSuccess) onSuccess();
            })
            .catch((error) => {
                console.error("Erreur mise à jour quantité:", error);
            });
    };

    // ── Supprimer du panier ────────────────────────────────────────
    const removeFromCart = () => {
        if (!LG_CPRID) {
            setIsAdded(false);
            return;
        }
        const payload = {
            mode: mode.deleteCommproduitMode,
            LG_CPRID: LG_CPRID,
            STR_UTITOKEN: userData.STR_UTITOKEN,
        };
        crudData(payload, apiEndpointe.CommandeManagerEndPoint)
            .then((response) => {
                if (response.data.code_statut === "1") {
                    setIsAdded(false);
                    setQuantity(1);
                    setLG_CPRID(null);
                    if (onSuccess) onSuccess();
                } else {
                    toast.error("Erreur lors de la suppression.");
                }
            })
            .catch((error) => {
                console.error("Erreur suppression panier:", error);
            });
    };

    return (
        <>
            <div className="product-wrap product-wrap-max-w flex-shrink-0 product-card">
                <div className="product text-center">
                    <figure className="product-media" style={{ position: 'relative' }}>
                        {product && parseInt(product.ArtStk) <= 0 && (
                            <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                backgroundColor: '#e74c3c',
                                color: 'white',
                                padding: '2px 10px',
                                borderRadius: '20px',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                zIndex: 1
                            }}>
                                Rupture de stock
                            </div>
                        )}
                        <Link to={`/${product.ArtSlug}`} onClick={handleClick}>
                            <img
                                src={`${
                                    product.ArtGPicID && /\.(jpg|jpeg|png|gif|webp)$/i.test(product.ArtGPicID)
                                        ? fullUrl + product.ArtGPicID
                                        : fullUrl + defaultImage
                                }`}
                                onError={(e) => { e.target.onerror = null; e.target.src = fullUrl + defaultImage; }}
                                alt={product.ArtLib}
                                width={300}
                                height={338}
                            />
                        </Link>
                    </figure>
                    <Link to={`/${product.ArtSlug}`} onClick={handleClick}>
                        <div className="product-details">
                            <div className="product-cat">
                                <span>{product?.ArtCateg}</span>
                            </div>
                            <h3 className="product-name">
                                <span>{product.ArtLib}</span>
                            </h3>
                            {userData && userData.STR_UTITOKEN && (
                                <div className="product-pa-wrapper">
                                    <div className="product-price">
                                        {formatPrice(parseInt(product?.ArtPrixBase))} FCFA
                                    </div>
                                    {/* {(() => {
                                        // ← Récupérer les prix négociés
                                        const prixNegocies = JSON.parse(localStorage.getItem("prixNegocies") || "{}")
                                        const prixCatalogue = parseInt(product?.ArtPrixBase) || 0
                                        
                                        // ← Chercher le prix négocié (avec ou sans point)
                                        const code = product?.ArtCode
                                        const codeAvecPoint = code?.endsWith('.') ? code : code + '.'
                                        const prixNegocie = prixNegocies[codeAvecPoint] || prixNegocies[code]
                                        
                                        const hasReduction = prixNegocie && prixNegocie < prixCatalogue
                                        const reductionPct = hasReduction
                                            ? Math.round(((prixCatalogue - prixNegocie) / prixCatalogue) * 100)
                                            : 0

                                        return hasReduction ? (
                                            <div className="product-price" style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                                
                                                <span style={{
                                                    background: "#e74c3c", color: "white",
                                                    fontSize: "11px", fontWeight: "700",
                                                    padding: "2px 8px", borderRadius: "12px",
                                                    width: "fit-content",
                                                }}>
                                                    -{reductionPct}%
                                                </span>
                                                
                                                <span style={{
                                                    textDecoration: "line-through",
                                                    color: "#999", fontSize: "13px",
                                                }}>
                                                    {formatPrice(prixCatalogue)} FCFA
                                                </span>
                                                
                                                <span style={{
                                                    color: "#e74c3c", fontSize: "18px", fontWeight: "700",
                                                }}>
                                                    {formatPrice(prixNegocie)} FCFA
                                                </span>
                                            </div>
                                        ) : (
                                            <div className="product-price">
                                                {formatPrice(prixCatalogue)} FCFA
                                            </div>
                                        )
                                    })()} */}
                                </div>
                            )}
                        </div>
                    </Link>

                    {/* ── Bouton Ajouter / Quantité ── */}
                    {userData && userData.STR_UTITOKEN && (
                        <div className="product-action-bottom mt-2">
                            {!isAdded ? (
                                // Bouton Ajouter au panier
                                <button
                                    onClick={handleAddToCart}
                                    disabled={isLoading || parseInt(product.ArtStk) <= 0}
                                    style={{
                                        backgroundColor: parseInt(product.ArtStk) <= 0 ? "#ccc" : "#214293",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "20px",
                                        padding: "8px 16px",
                                        cursor: isLoading || parseInt(product.ArtStk) <= 0 ? "not-allowed" : "pointer",
                                        fontFamily: "Poppins",
                                        fontSize: "1.5rem",
                                        width: "100%",
                                        opacity: isLoading ? 0.7 : 1,
                                    }}
                                >
                                    {isLoading ? "Ajout..." : parseInt(product.ArtStk) <= 0 ? "Rupture" : "Ajouter au panier"}
                                </button>
                            ) : (
                                // Bouton Quantité +/-
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "20px",
                                        border: "2px solid #214293",
                                        borderRadius: "20px",
                                        padding: "4px 8px",
                                        height: "38px",
                                        fontSize: "1.5rem"
                                    }}
                                >
                                    <button
                                        onClick={handleDecrease}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            color: "#214293",
                                            fontSize: "2rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            padding: "0 6px",
                                        }}
                                    >
                                        −
                                    </button>
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            color: "#214293",
                                            minWidth: "20px",
                                            textAlign: "center",
                                        }}
                                    >
                                        {quantity}
                                    </span>
                                    <button
                                        onClick={handleIncrease}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            color: "#214293",
                                            fontSize: "2rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            padding: "0 6px",
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Popup ajout panier */}
            {isPopupOpen && (
                <div className="minipopup-area">
                    <div className="minipopup-box show" style={{ top: 0 }}>
                        <div className="product product-list-sm product-cart">
                            <div className="product-details">
                                <h4 className="product-name">{product.ArtLib}</h4>
                                <p>Ajouté au panier</p>
                            </div>
                        </div>
                        <div className="product-action">
                            <NavLink to={"/panier"} className="btn btn-rounded btn-sm">
                                Voir le panier
                            </NavLink>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProductWrap;